import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'soph-template-correo',
  standalone: true,
  imports: [],
  templateUrl: './template-correo.component.html',
  styleUrl: './template-correo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateCorreoComponent {

}
